module.exports = __webpack_public_path__ + "static/images/pass-card-open.01f6ec5.png";